import React from 'react';
import styles from './Header.module.css';

export default function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.headingContent}>
        <h1 className={styles.title}>Welcome to My Site</h1>
        <p className={styles.subtitle}>This is a cool header with a built-in nav bar below.</p>
      </div>
    </header>
  );
}
